import React, { Component } from 'react';

import { InputBlock, InputBlockIcon } from 'components/input';
import { I18n } from 'components/translate';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import { TabBoxMedia } from 'modules/content/components/media';
import { isVideo } from 'modules/file/helpers';
import PropTypes from 'prop-types';

class MediaUploadGroup extends Component {
  static propTypes = {
    className: PropTypes.string,
    description: PropTypes.string,
    icon: PropTypes.string,
    mediaUrl: PropTypes.string,
    name: PropTypes.string,
    entityType: PropTypes.string,
    onTabChange: PropTypes.func,
    selected: PropTypes.number,
    setMediaUrl: PropTypes.func,
    value: PropTypes.object,
    onChange: PropTypes.func,
    labelValue: PropTypes.string,
    submitted: PropTypes.bool
  };

  state = {
    media: void 0,
    mediaUrl: void 0,
    selected: 0
  };

  static getDerivedStateFromProps(props, state) {
    if (
      !isEqual(props.value, state.media) ||
      props.mediaUrl !== state.mediaUrl
    ) {
      const selected = MediaUploadGroup.getSelected(
        state.selected,
        props.value,
        props.mediaUrl
      );

      return { selected, media: props.value, mediaUrl: props.mediaUrl };
    }

    return null;
  }

  static getSelected(selected, media, mediaUrl) {
    if (!isEmpty(media) && !isVideo(media)) {
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      selected = 2;
    } else if (mediaUrl) {
      selected = 1;
    }

    return selected;
  }

  get items() {
    const { value } = this.props;

    return !isEmpty(value) ? [value] : [];
  }

  onTabChange = (selected) => {
    this.setState({ selected });
  };

  onMediaChanged = (items) => {
    this.clearMediaUrl();
    this.setMedia(items);
  };

  onMediaUrlChanged = (mediaUrl) => {
    this.clearMedias();
    this.setMediaUrl(mediaUrl);
  };

  clearMedias() {
    if (!isEmpty(this.props.value)) {
      this.setMedia([]);
    }
  }

  clearMediaUrl() {
    if (!isEmpty(this.props.mediaUrl)) {
      this.onMediaUrlChanged();
    }
  }

  setMedia = (items) => {
    const { onChange, name } = this.props;

    const target = { name, value: items[0] };

    onChange && onChange({ target });
  };

  setMediaUrl = (mediaUrl) => {
    const { setMediaUrl } = this.props;

    setMediaUrl && setMediaUrl(mediaUrl);
  };

  render() {
    const {
      description,
      labelValue,
      mediaUrl,
      name,
      submitted,
      entityType,
      ...props
    } = this.props;
    const { selected } = this.state;

    const InputBlockComponent = this.props.icon ? InputBlockIcon : InputBlock;

    return (
      <InputBlockComponent
        name={name}
        labelValue={labelValue}
        submitted={submitted}
        {...props}
      >
        {description && (
          <p className="secondary">
            <I18n label={description} />
          </p>
        )}

        <TabBoxMedia
          {...props}
          id={name}
          mediaUrl={mediaUrl}
          name={name}
          items={this.items}
          onTabChange={this.onTabChange}
          onItemsChange={this.onMediaChanged}
          selected={selected}
          setMediaUrl={this.onMediaUrlChanged}
          entityType={entityType}
        />
      </InputBlockComponent>
    );
  }
}

export default MediaUploadGroup;
